'use client';

import { Box, Skeleton } from '@mui/material';

export const SearchResultItemSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.25,
        borderRadius: '10px',
      }}
    >
      <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: '8px' }} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="40%" height={16} sx={{ mt: 0.5 }} />
      </Box>
    </Box>
  );
};
